<script>
  import { Modal } from 'bootstrap';
  import { onMount } from 'svelte';
  import FormTextarea from './FormControls/FormTextarea.svelte';
  import { configItem } from './Helper';
  import Loader from '../components/Loader.svelte';
  export let handleClick = (e) => {};
  let reason = '';
  let addReasonsModal;
  let isLoading = false;
  onMount(() => {
    addReasonsModal = new Modal(document.getElementById('taskChangeAssignee'), {
      keyboard: false,
    });
  });
  let taskParams = {
    selectedTasks: [],
    unitUsers: [],
  };
  let selectedValue;
  let showError = false;
  export const showModal = (params) => {
    isLoading = false;
    showError = false;
    selectedValue = null;
    taskParams = params;
    reason = '';
    addReasonsModal.show();
  };
  let assigneeUserId;
  import Select from 'svelte-select';
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="taskChangeAssignee"
  tabindex="-1"
  aria-labelledby="changeAssigneeModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    {#if isLoading}
      <div class="modal-content p-5 text-center">
        <div class="p-5">
          <Loader Style="loader-block" />
        </div>
      </div>
    {:else}
      <div class="modal-content">
        <div class="modal-header">
          <h5
            class="modal-title font-size-14 border-0"
            id="exampleModalLabel"
          >
            Change Assignee
          </h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div
            class="form-group select-block select-client-type position-relative {showError
              ? 'error'
              : ''}"
          >
            <label
              for=""
              class="mb-3 color-lead">{taskParams.selectedTasks.length} Tasks selected</label
            >
            <div class="form-group mb-3">
              <label
                for=""
                class="form-label">Select Assignee</label
              >
              <Select
                showChevron={true}
                isClearable={true}
                containerClasses="form-control"
                bind:selectedValue={selectedValue}
                placeholder="Select Assignee"
                items={taskParams.unitUsers}
                getSelectionLabel={(option) => {
                  return option.firstName + ' ' + option.lastName;
                }}
                optionIdentifier="userId"
                getOptionLabel={(option) => {
                  return option.firstName + ' ' + option.lastName;
                }}
                on:select={(ev) => {
                  showError = false;
                  assigneeUserId = ev.detail.userId;
                }}
              ></Select>
              {#if showError}
                <label
                  class="formError"
                  for="name">Please select assignee</label
                >
              {/if}
            </div>
          </div>
          <div class="form-group">
            <FormTextarea
              label="Please tell us why you are making this change?"
              placeholder="Enter Notes (Optional)"
              name="updateReason"
              bind:value={reason}
              maxLength={configItem.maxLength.description}
              rows="6"
            />
          </div>
        </div>
        <div class="modal-footer border-0">
          <button
            type="button"
            class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
            data-bs-dismiss="modal">Cancel</button
          >
          <button
            type="button"
            class="btn btn-primary m-0 px-4 font-size-12"
            on:click={() => {
              if (assigneeUserId != undefined && assigneeUserId > 0) {
                showError = false;
                isLoading = true;
                handleClick({ assigneeUserId, reason });
                addReasonsModal.hide();
              } else {
                showError = true;
              }
            }}>Done</button
          >
        </div>
      </div>
    {/if}
  </div>
</div>
